import axios from '../axios-auth';
import orginal_axios from "axios";

export const stockMovementService = {
    stockMovementReportList,
    allStockMovementReportList,
    exportAllStockMovementReport
}
function stockMovementReportList(searchParams, page, size) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    if (searchParams.maxQty) {
        params["maxQty"] = searchParams.maxQty;
    }
    if (searchParams.minQty) {
        params["minQty"] = searchParams.minQty;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.brand) {
        params["brand"] = searchParams.brand;
    }
    if (searchParams.category) {
        params["category"] = searchParams.category;
    }
    return axios.get("/auth/stock-movement", { params });
}

function allStockMovementReportList(searchParams) {
    let params = {};
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.maxQty) {
        params["maxQty"] = searchParams.maxQty;
    }
    if (searchParams.minQty) {
        params["minQty"] = searchParams.minQty;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.brand) {
        params["brand"] = searchParams.brand;
    }
    if (searchParams.category) {
        params["category"] = searchParams.category;
    }
    return axios.get("/auth/stock-movement", { params });
}

function exportAllStockMovementReport(searchParams) {
    let params = {}
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    if (searchParams.maxQty) {
        params["maxQty"] = searchParams.maxQty;
    }
    if (searchParams.minQty) {
        params["minQty"] = searchParams.minQty;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.brand) {
        params["brand"] = searchParams.brand;
    }
    if (searchParams.category) {
        params["category"] = searchParams.category;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stock-movement-report-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}